// extracted by mini-css-extract-plugin
export default {"container":"cardaction_container__QKPIF","center":"cardaction_center__0ozGG","middle":"cardaction_middle__yyaIa","left":"cardaction_left__NnPb4","right":"cardaction_right__uu-bJ"};